module.exports = __webpack_public_path__ + "img/doctor-with-patient.f5d2297d.png";